import {React, useState} from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import Modal from 'react-bootstrap/Modal';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <button type="button" className={ `slick-next ${className}`} style={{ ...style }} onClick={onClick} ><i className="fal fa-angle-right"></i></button>
    );
}
  
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
    <button type="button" className={ `slick-prev ${className}`} style={{ ...style }} onClick={onClick} ><i className="fal fa-angle-left"></i></button>
      
    );
}

function Awards() {
    const awards = [
        {
            category: 'Assistant Subject Editor',
            title: 'Assistant Subject Editor, International Journal of Hydrogen Energy, Elsevier [Q1 category, Impact factor 8.1.]',
            description: 'Prof. Muthukumar Palanisamy has been appointed Assistant Subject Editor for the International Journal of Hydrogen Energy..',
            link: '/',
            img: 'https://files.iittp.ac.in/images/demo/iit/Prof.Muthukumar.jpg',
            About: "Prof. Muthukumar Palanisamy has been appointed Assistant Subject Editor for the International Journal of Hydrogen Energy, a prestigious Q1 journal in the field of hydrogen energy."
        },
        {
            category: 'Associate Editor',
            title: 'Associate Editor, Journal of Manufacturing Processes (Elsevier)',
            description: 'Prof. Mamilla Ravi Sankar, Professor (Mechanical Engineering) nominated as Associate Editor...',
            link: '/',
            img: 'https://files.iittp.ac.in/images/demo/iit/EVMRS.JPG',
            About: "Prof. Mamilla Ravi Sankar, Professor (Mechanical Engineering) nominated as Associate Editor, Journal of Manufacturing Processes (Elsevier). This is one of the top Manufacturing Journals."
        },
        {
            category: 'Research Board',
            title: 'International Member of the USNAE Transportation Research Board..',
            description: 'Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Based...',
            link: '/',
            img: 'https://files.iittp.ac.in/images/demo/iit/krishna1.jpg',
            About: "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Based on his team’s research contributions in the areas of roadway noise and modeling, has been appointed an International Member of the USNAE Transportation Research Board Standing Committee on Transportation-Related Noise and Vibration: 2024-27."
        },
        {
            category: 'Abdul Kalam Technology',
            title: 'Abdul Kalam Technology Innovation National Fellowship',
            description: 'Prof. Muthukumar Palanisamy was honored with the Abdul Kalam Technology Innovation National Fellowship for the period..',
            link: '/',
            img: 'https://files.iittp.ac.in/images/demo/iit/Prof.Muthukumar.jpg',
            About: "Prof. Muthukumar Palanisamy was honored with the Abdul Kalam Technology Innovation National Fellowship for the period 2021–2026."
        },
        {
            category: 'Award',
            title: 'Chandran Menon Memorial Award',
            description: 'Dr. Ajay Kumar, Assistant Professor (Mechanical Engineering Department) received...',
            link: '/',
            img: 'https://files.iittp.ac.in/images/demo/iit/Ajay_Kumar_New.png',
            About: "Dr. Ajay Kumar, Assistant Professor (Mechanical Engineering Department) received the Chandran Menon Memorial Award for Applied Research & Innovative Technology for 2022 - 23. The award was given in the 72nd INDIAN FOUNDRY CONGRESS(IFC) on 2nd February 2024, at BIEC, Bengaluru, Karnataka"
        },

        {
            category: 'Achievement',
            title: 'Life Time Achievement Award',
            description: 'Prof KSMS Raghava Rao has been awarded the prestigious Life Time Achievement...',
            link: '/',
            img: 'assets/img/awards/raghavarao.png',
            About: "Prof KSMS Raghava Rao has been awarded the prestigious  Life Time Achievement Award  by International Association of Engineering and Food. He will receive the award at ICEF14 to be held at Nantes, France in 19-23 June 2023. ",        
        },
        // {
        //     category: 'Indian Standard',
        //     title: 'Member to the panel of Revision of Indian Standard (IS)',
        //     description: 'Dr. B. Janaki Ramaiah co-opted as a member to the panel of Revision of Indian Standard...',
        //     link: '/',
        //     img: 'assets/img/awards/JanakiRamaiah.jpg',
        //     About: "Dr. B. Janaki Ramaiah co-opted as a member to the panel of Revision of Indian Standard (IS) 4968- “Method for subsurface sounding for soils” and Indian Standard (IS) 10589- “Equipment for subsurface sounding of soils” under BIS Section “Soil and Foundation Engineering CED 43:P14002E”. ",
        // },
        {
            category: 'Research',
            title: 'DAAD Research Ambassador',
            description: 'Dr. Panchatcharam Mariappan is honoured as DAAD Research Ambassador. The tenure...',
            link: '/',
            img: 'assets/img/awards/PanchatcharamNUMA.jpg',
            About: "Dr. Panchatcharam Mariappan is honoured as DAAD Research Ambassador. The tenure ship of this honorary position is three years (2022 to 2025). ",
        },
        {
            category: 'Research',
            title: 'Chemical Research Society of India (CRSI)’s Bronze Medal',
            description: 'Prof. Gouriprasanna Roy (Professor, Chemistry) was awarded the Chemical...',
            link: '/',
            img: 'assets/img/awards/Gouriprasanna.png',
            About: "Prof. Gouriprasanna Roy (Professor, Chemistry) was awarded the Chemical Research Society of India (CRSI)’s Bronze Medal for 2020 in 26th CRSI-National Symposium in Chemistry (CRSI-NSC – 2020), VIT, Vellore, 7 – 9 February 2020, for his significant contributions to chemistry in the area of bioinorganic and coordination chemistry.",
            
        },
        {
            category: 'Research',
            title: 'Research Excellence Award',
            description: 'Dr. Shihabudhen M. Maliyekkal received Research Excellence Award under the...',
            link: '/',
            img: 'assets/img/awards/Shihab.png',
            About: "Dr. Shihabudhen M. Maliyekkal received Research Excellence Award under the subcategory “Teaching Faculty” at IEI - FCRIT Excellence Award 2019, Mumbai for his contribution to research.",
        },
       
    ];

    const settings = {
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: <SamplePrevArrow/>,
        nextArrow: <SampleNextArrow/>,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const [showModal, setShowModal] = useState(false);
    const [selectedAward, setSelectedAward] = useState(null);

    const toggleModal = (award) => {
        setSelectedAward(award);
        setShowModal(!showModal);
    };

    // Popup component
    const Popup = ({ onClose, profile }) => {
        return (
          <div className="popup">
            <div className="popup-content">
              <h2>{profile.title}</h2>
              <p>{profile.About}</p>
              <button onClick={onClose}>Close</button>
            </div>
          </div>
        );
      };

    const [showPopup, setShowPopup] = useState(false);

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    return (
        <>
         {/* style={{background:'#c9e2f1'}} */}
            <section className="courses csec pt-80 pb-80 p-relative fix" style={{backgroundColor : 'lightblue'}}>
                <div id='wave'></div>
                
                <div className="container">
                <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                {/* <h5>
                                    <i className="fal fa-graduation-cap" /> Awards
                                </h5> */}
                                <h2 className='titleh3'>Awards</h2>
                            </div>
                        </div>
                    </div>
                    <Slider className="row class-active" {...settings}>
                        {awards.map((award, index) => (
                            
                            <div key={index} className="col-lg-4 col-md-6 ">
                                
      
    
                                <div className="courses-item mb-30 hover-zoomin"  onClick={() => toggleModal(award)}>
                                    <div className="thumb fix">
                                        <Link to={award.link} >
                                            <img src={award.img} alt="contact-bg-an-01" />
                                        </Link>
                                    </div>
                                    <div className="courses-content">
                                        <div className="cat">
                                            <i className="fal fa-thin fa-award" /> {award.category}
                                        </div>
                                        <h5 style={{minHeight:"50px"}}>
                                            <Link to={award.link}>{award.title}</Link>
                                        </h5>
                                        <p>
                                            {award.description}
                                        </p>
                                        <Link to={award.link} className="readmore">
                                            Read More <i className="fal fa-long-arrow-right" />
                                        </Link>
                                    </div>
                                    <div className="icon">
                                        <img src="assets/img/icon/trophy.png" alt="img" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                    {showPopup && selectedAward && <Popup onClose={() => setShowPopup(false)} profile={selectedAward} />} {/* Render popup with selected award */}
                    <Modal show={showModal} onHide={() => setShowModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>{selectedAward?.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>{selectedAward?.About}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                        </Modal.Footer>
                    </Modal>
                    <div className="slider-btn mt-10 float-end">
                        <Link to="/awards" className="btn ss-btn smoth-scroll">
                            View All <i className="fal fa-long-arrow-right" />
                        </Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Awards